export default () => {
  return {
    children: [],
    updateTimer: null
  }
}
